import type { ReactElement } from "react"

/**
 * Matched to `BookLink` and `ManageAccess`'s stroke weight and 20px sizing so
 * all three read as one icon family.
 *
 * `currentColor` throughout, so it takes whatever colour the button around it sets.
 */
export const Gift = ({ size = 20 }: { readonly size?: number }): ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3" y="8" width="18" height="4" />
    <rect x="4" y="12" width="16" height="9" />
    <path d="M12 8v13" />
    <path d="M12 8c-1.5-4-6.5-4-6.5-1S9 8 12 8z" />
    <path d="M12 8c1.5-4 6.5-4 6.5-1S15 8 12 8z" />
  </svg>
)
